import React, { useEffect } from "react";
import { useContext } from "react";
import { useParams,useNavigate } from "react-router-dom";
import { AllowRouteVerification } from "./Context";
import MailIcon from '@mui/icons-material/Mail';
import { Alert, AlertTitle,Typography, Box,  Button, Container  } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DisplayLogo from "./LogoDisplay";






export const EmailVerify = () => {

    
    const navigate = useNavigate()
    const {useremail,status} = useParams()


    

    if (status ===  "failed") {
            <Box
                sx={{
                position: "absolute",
                top: "10%",
                left: "50%",
                transform: "translateX(-50%)",
                maxWidth: 400,
                width: "90%",
                textAlign: "center",
                }}
            >
                <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                }}
                >
                <WarningAmberIcon fontSize="large" sx={{ fontSize: 40, color: "#FF0000" }} /> {/* Red close icon */}
                </Box>

            
                <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 1,
                }}
                >
                <MailIcon
                    fontSize="large"
                    sx={{ fontSize: 50, color: "rgba(0, 0, 255, 0.3)" }} 
                />
                </Box>
              
                <Alert
                severity="error"
                icon={false} 
                sx={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    padding: "16px",
                    alignItems: "center",
                    borderRadius: 2,
                    backgroundColor: "transparent",
                    color: "#000000", 
                    boxShadow: "none", 
                    textAlign: "center", 
                }}
                >
                <AlertTitle sx={{ fontWeight: "bold" }}>Failed</AlertTitle>
                <Typography component="span" sx={{ fontWeight: "normal" }}>
                    Failed to deliver the verification email. Please try again later.
                </Typography>
                </Alert>
            </Box>
    }
    else if (status === "success") {
        return(
            <Box
            sx={{
              position: "absolute",
              top: "10%",
              left: "50%",
              transform: "translateX(-50%)",
              maxWidth: 400,
              width: "90%",
              textAlign: "center",
            }}
          >
            <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <CheckIcon fontSize="large" sx={{ fontSize: 40, color: "#4CAF50" }} /> {/* Green check icon */}
      </Box>

    <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 1,
        }}
      >
        <MailIcon
          fontSize="large"
          sx={{ fontSize: 50, color: "rgba(0, 0, 255, 0.3)" }} // Transparent blue MailIcon
        />
      </Box>
            
            <Alert
              severity="success"
              icon={false} 
              sx={{
                fontSize: "16px",
                fontWeight: "normal",
                padding: "16px",
                alignItems: "center",
                borderRadius: 2,
                backgroundColor: "transparent", 
                color: "#000000", 
                boxShadow: "none", 
                textAlign: "center", 
              }}
            >
              <AlertTitle sx={{ fontWeight: "bold" }}>Success</AlertTitle>
              <Typography component="span" sx={{ fontWeight: "normal" }}>
                We’ve sent a verification link to your email inbox. Please check your{" "}
              </Typography>
              <Typography component="strong" sx={{ fontWeight: "bold" }}>
                {useremail}
              </Typography>
              <Typography component="span" sx={{ fontWeight: "normal" }}>
                {" "}and click the link to complete your registration.
              </Typography>
            </Alert>
          </Box>
    )
    }
        
    
}




                

export  function VerificationExpired() {
  
    

    const handleResendVerification = () => {
        console.log("Resend verification email");
    };
    
    
    return(
            <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "5rem" }}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <ErrorOutlineIcon sx={{ fontSize: 60, color: "red" }} />
                        <Typography variant="h4" gutterBottom>
                          Verification Link is Invalid
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                          The verification link you followed has expired or invalid
                        </Typography>
                        {/* <Button
                          variant="contained"
                          color="primary"
                          onClick={handleResendVerification}
                          sx={{ mt: 2 }}
                        >
                          Resend Verification Email
                        </Button> */}
                      </Box>
                    </Container>
        )
    }
  
  

